import React from 'react';
import { updateSpace } from '../../app-main/actions/spaces';
import { SubmissionError } from 'redux-form';
import { get } from 'lodash';
import { push } from 'react-router-redux';
import { FormattedMessage } from 'react-intl';

const onSubmitPolicy = (values, dispatch, props) => {
  const payload = {
    policy_accepted: new Date().toISOString()
  };

  const { spaceId } = props.params;
  const SSOid = get(props, 'profile.SSOid');
  const errorMessage = <FormattedMessage id="hosting.on_submit_policy.error_message" defaultMessage="Submission failed. Please refresh and try again." />;

  dispatch(updateSpace(spaceId, payload))
    .then(() => {
      analyticsIntegrations.trackEvent('accepted host policies', {
        user_id: SSOid,
        space_id: spaceId
      });

      dispatch(push(`/your-space/${spaceId}/profile`));
    })
    .catch(() => {
      throw new SubmissionError({ _error: errorMessage });
    });
};

export default onSubmitPolicy;
